/* ============
 * Product Type Transformer
 * ============
 *
 * The transformer for the productSubtype.
 */

import Transformer from './transformer';

export default class ProductSubtypeTransformer extends Transformer {

  static fetch(productSubtype) {
    return {
      id: productSubtype.id,
      name: productSubtype.name,
      type: productSubtype.type,
      productType: productSubtype.product_type,
      productTypeId: productSubtype.product_type_id,
    };
  }

  static send(productSubtype) {
    return {
      id: productSubtype.id,
      name: productSubtype.name,
      type: productSubtype.type,
      product_type: productSubtype.productType,
      product_type_id: productSubtype.productTypeId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productSubtype.js